import { Injectable } from '@angular/core';
import { UserManager, UserManagerSettings, User } from 'oidc-client';
import { environment } from '../../../../../environments/environment';
import { UserModel } from '../models/user.model';
import { AuthAdapter } from './auth-adapter';

@Injectable({
  providedIn: 'root'
})
export class OpenId implements AuthAdapter{
  private userManager: UserManager;
  private user;

  constructor() {
    this.userManager = new UserManager(environment.auth['settings']);
  }

  public getUserInfo() {
    return this.userManager.getUser().then((user) => {
      if (user) {
        this.user = new UserModel(user);
      }
    });
  }

  public isAuthenticated() {
    return !!this.user;
  }

  public login(): Promise<void> {
    return this.userManager.signinRedirect();
  }

  public renewToken(): Promise<User> {
    return this.userManager.signinSilent();
  }

  public logout(): Promise<void> {
    return this.userManager.signoutRedirect();
  }

  public getToken() {
    return this.user['access_token'];
  }

  public getUsername() {
    return this.user['username'];
  }
}
